import { render, staticRenderFns } from "./DocTail.vue?vue&type=template&id=71d18b30&"
import script from "./DocTail.vue?vue&type=script&lang=js&"
export * from "./DocTail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports